/**
 * https://linear.app/redo/issue/RETCO-5036/auguste-the-label-redo-assigning-incorrect-values-for-products-leading
 * Safe to remove after 30-day return window (2025-06-15)
 **/
export const temporaryOrderTaxIncludedList: string[] = [
  "67f46f0c8d79e6978363ceeb",
  "67f4780e8d79e697836455c9",
  "67ff08431ae9b355546d4218",
  "67ff262c1ae9b3555471b0fd",
  "67ff0f731ae9b35554700523",
  "67f6ff2c8d79e69783960dbe",
  "67f767b28d79e697839c6ca7",
  "67f709b18d79e69783968774",
  "67ff28a41ae9b3555471d24b",
  "67f8554e8d79e69783b16a18",
  "67f774738d79e697839ccc48",
  "67f8376c8d79e69783aae319",
  "67f8627a8d79e69783b225cd",
  "67f87ac58d79e69783b363bb",
  "67f87c6b8d79e69783b37723",
  "67ff26791ae9b3555471b3e3",
  "67fb01428d79e69783e9f7e3",
  "67fc2d5d1ae9b3555437497f",
  "680072b31ae9b3555491fa3b",
  "680079c61ae9b35554925e60",
  "68195d05f233ca240c605d73",
  "67fc994a1ae9b355543d121a",
  "67fcaff41ae9b355543dc502",
  "67fe2d401ae9b3555456b696",
  "680044981ae9b355548e18a4",
  "6807326a1ae9b355540df7c6",
  "68086d0d1ae9b35554280ca5",
  "68087add1ae9b3555428979c",
  "6808906d1ae9b3555429715e",
  "6809b2bf1ae9b355543ccb00",
  "680acbe11ae9b3555457062d",
  "680c798c1ae9b35554805f7d",
  "680db3cd1ae9b355549378e5",
  "6822951183ae582e17811169",
  "680ecef1f233ca240c59364e",
  "680eec56f233ca240c5aec80",
  "680ef96af233ca240c5b810f",
  "680f0113f233ca240c5bd52a",
  "68100671f233ca240c71f9d1",
  "68101d9ef233ca240c74ff3f",
  "68103a9cf233ca240c77a65e",
  "6811752cf233ca240c9a19f5",
  "6811755cf233ca240c9a1d9a",
  "68117dacf233ca240c9ac750",
  "6811ae2af233ca240c9dd16a",
  "681aef04f233ca240ccbb474",
  "6812efb3f233ca240cc813cc",
  "6822a80283ae582e1782cbe2",
  "68130957f233ca240cc9ab95",
  "68134d91f233ca240cce2358",
  "681360daf233ca240ccf4b39",
  "68138a5df233ca240cd353b4",
  "68140546f233ca240ce5be1d",
  "68145a18f233ca240cedff3c",
  "68228c3183ae582e178050b2",
  "681475cbf233ca240cef8fe6",
  "6822930783ae582e1780ed91",
  "6816c1e9f233ca240c2f796e",
  "6817fbd5f233ca240c41d2c6",
  "68180be2f233ca240c437166",
  "681a9c42f233ca240cc5b227",
  "681a9d90f233ca240cc5c44d",
  "681b2eeef233ca240cce67ca",
  "681b15aef233ca240ccd6b4a",
  "681c36dcf233ca240ce6559d",
  "681d9c61f233ca240c0a55bf",
  "681e9601f233ca240c3102ea",
  "6821348183ae582e175d6381",
  "682133cc83ae582e175d59ac",
  "682178d883ae582e17617239",
  "6822893d83ae582e177feae0",
  "6822de1583ae582e1786c47e",
  "6823e60d83ae582e17a204d5",
  "6823f2be83ae582e17a340d8",
  "682435a283ae582e17a6b758",
  "682472da83ae582e17a91de2",
  "682478d483ae582e17a95840",
  "68247e6e83ae582e17a99c03",
  "682544b583ae582e17bfca13",
  "68255f1b83ae582e17c1cedb",
  "6825731b83ae582e17c31349",
  "68256d8083ae582e17c2bb5f",
  "68259c6d83ae582e17c62627",
];
